"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoWidgetConfig = exports.createVideoNode = void 0;
var Text_1 = require("@CommonFrontend/ContentTokens/DataModels/Text");
var react_1 = __importDefault(require("react"));
var MakeConfig_1 = require("../Utils/MakeConfig");
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var VideoWidget_1 = require("Project/QwilrEditor/Widgets/VideoWidget/VideoWidget");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var Video_1 = require("@CommonFrontend/ContentTokens/DataModels/Video");
var Serialise_1 = require("Project/QwilrEditor/Tokenization/Serialise");
var NormalizeVoidNode_1 = require("Project/QwilrEditor/Schemas/NormalizeVoidNode");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var WidgetActions_1 = require("Project/QwilrEditor/Behaviours/WidgetActions");
var TelemetryParameterValue_1 = require("@CommonFrontend/Telemetry/TelemetryParameterValue");
var createVideoNode = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.displayUrl, displayUrl = _c === void 0 ? "" : _c, _d = _b.embedUrl, embedUrl = _d === void 0 ? "" : _d;
    return {
        type: "video",
        children: [Text_1.text.createSlateJson()],
        isVoid: true,
        data: __assign({ displayUrl: displayUrl }, (0, CommonUtils_1.includeIf)(!!embedUrl, { embedUrl: embedUrl })),
    };
};
exports.createVideoNode = createVideoNode;
exports.videoWidgetConfig = (0, MakeConfig_1.makeConfig)(__assign(__assign({}, (0, GetCommonConfigByType_1.getCommonConfigByType)("video")), { editorRender: VideoWidget_1.VideoWidget, toolbarButtons: VideoWidget_1.VideoToolbarButtons, node: {}, nodeType: "void", serialise: function (node, editor, commentTracker, selection) {
        var token = __assign(__assign(__assign({ type: "block", subType: "video" }, (0, CommonUtils_1.includeIf)(!!node.data.displayUrl, { displayUrl: node.data.displayUrl })), (0, CommonUtils_1.includeIf)(!!node.data.embedUrl, {
            embedUrl: (0, Video_1.updateEmbedUrlPrefix)(node.data.embedUrl),
        })), (0, CommonUtils_1.includeIf)(!!node.data.variable, {
            variable: node.data.variable,
        }));
        return __spreadArray([token], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false);
    }, deserialise: function (token) {
        var _a;
        return {
            type: "video",
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
            data: __assign(__assign({ displayUrl: (_a = token.displayUrl) !== null && _a !== void 0 ? _a : "", width: token.width }, (0, CommonUtils_1.includeIf)(!!token.embedUrl, { embedUrl: (0, Video_1.updateEmbedUrlPrefix)(token.embedUrl) })), (0, CommonUtils_1.includeIf)(!!token.variable, {
                variable: token.variable,
            })),
        };
    }, normalizeWidget: function (node, path, editor) { return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor); }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validEditors: ["standard"], validContainers: ["accordionBody", "contentLoopBody", "sideBySideColumn", "boxColumn", "layoutColumn"], widgetAdderConfig: {
        tags: ["youtube", "vimeo", "wistia", "brightcove", "media"],
        icon: react_1.default.createElement(icons_1.WidgetVideo, null),
        displayName: "Video",
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        var node = (0, exports.createVideoNode)();
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: node,
        });
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Video, width: "full-width" }));
